function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.46,60.92a19.46,19.46,0,0,1,0-38.92H35a1,1,0,0,1,.832.445L37.535,25h6.93l1.7-2.555A1,1,0,0,1,47,22H70a1,1,0,0,1,.964,1.266l-4.47,16.22a1,1,0,0,1-.964.734H41.873c.032.431.047.838.047,1.24A19.482,19.482,0,0,1,22.46,60.92Zm0-36.92A17.46,17.46,0,1,0,39.92,41.46a17.284,17.284,0,0,0-.143-2.118,1,1,0,0,1,.992-1.122h24L68.688,24H47.535l-1.7,2.555A1,1,0,0,1,45,27H37a1,1,0,0,1-.832-.445L34.465,24Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.46,52A10.54,10.54,0,1,1,33,41.46,10.552,10.552,0,0,1,22.46,52Zm0-19.08A8.54,8.54,0,1,0,31,41.46,8.55,8.55,0,0,0,22.46,32.92Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.137,18a1,1,0,0,1-.939-.658l-2.546-7a1,1,0,1,1,1.879-.684l2.546,7A1,1,0,0,1,35.137,18Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5,18a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v7A1,1,0,0,1,41.5,18Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.863,18a1,1,0,0,1-.939-1.342l2.546-7a1,1,0,1,1,1.879.684l-2.546,7A1,1,0,0,1,47.863,18Z"
});

var SvgTrainWhistle = function SvgTrainWhistle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 74 74",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrainWhistle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trainWhistle.ff50b1c5.svg";
export { ForwardRef as ReactComponent };